import React, { useState } from "react";
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  Tooltip,
  Avatar,
} from "@mui/material";
import { handleLogout } from "../../redux/reducers/authReducer";
import { useDispatch } from "react-redux";
import { Menu, MenuItem } from "@mui/material";
import { useSelector } from "react-redux";
import LogoNav from "../../assets/images/logo-red1.png";
import MiniLogoIcon from "../../assets/images/ico.png";
import TicketIcon from "../../assets/images/ticket-01.png";
import AiIcon from "../../assets/icons/icon.png";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import CardSvgIcon from "../styled/CardSvIcon";
import PickupIconSvg from "../styled/PickupIconSvg";
import ReportIconSvg from "../styled/ReportIconSvg";
import ShipmentIconSvg from "../styled/ShipmentIconSvg";
import AddShipmentIconSvg from "../styled/AddShipmentIconSvg";
import AnalysisIconSvg from "../styled/AnalysisIconSvg";
import WalletSvgIcon from "../styled/WalletSvgIcon";
import SettingsIconSvg from "../styled/SettingsIconSvg";
import AddPickupIconSvg from "../styled/AddPickupIconSvg";
import HomeIconSvg from "../styled/HomeIconSvg";
import MessageIconSvg from "../styled/MessageIconSvg";
import AdvancedSearchSvg from "../styled/AdvancedSearchSvg";
import LogoNavCompany from "../../assets/images/boy.png";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const ToggleSidebarButton = styled(({ open, isrtl, ...rest }) => (
  <IconButton {...rest} />
))`
  background-color: #ffffffff;
  border: 1px solid #c2c0c0ff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  position: absolute;
  top: 20px;
  ${(props) => (props.isrtl ? "right" : "left")}: ${(props) =>
    props.open ? "260px" : "55px"};
  z-index: 2000;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
`;

const Logo = styled.img`
  height: 60px;
  @media (max-width: 768px) {
    height: 40px;
  }
`;

const ClientType = styled.div`
  font-size: 12px;
  color: gray;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
  @media (max-width: 768px) {
    margin-left: 10px;
    display: none;
    gap: 5px;
  }
`;

const drawerWidth = 280;

const SidebarWrapper = styled(Box)`
  display: flex;
`;

const DrawerContent = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 5px 0;
  gap: 5px;
  align-self: center;
  width: 85%;
  flex-grow: 1;
`;

const DrawerItem = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  border-radius: 8px;
  text-decoration: none;
  color: #333;
  font-family: cairo;
  font-size: 16px;

  transition: background 0.3s;
  justify-content: ${(props) => (props.open ? "flex-start" : "center")};

  &.active,
  &:hover {
    background-color: #ffebee;
    border-radius: 50px;
    color: #b00101;
  }
`;

export default function Sidebar() {
  const { i18n, t } = useTranslation("layout");
  const isRTL = i18n.language === "ar";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const { ClientName } = useSelector((state) => ({
    ClientName: state.Auth.AuthedUser.ClientName,
  }));

  return (
    <SidebarWrapper>
      <Menu anchorEl={anchorEl} open={openMenu} onClose={handleCloseMenu}>
        <MenuItem
          onClick={handleCloseMenu}
          component="a"
          href="/change-password"
        >
          {t("Navbar.change_password")}
        </MenuItem>
        <MenuItem onClick={() => dispatch(handleLogout())}>
          {t("Navbar.signout")}
        </MenuItem>
      </Menu>
      <ToggleSidebarButton
        onClick={() => setOpen(!open)}
        open={open}
        isrtl={isRTL}
      >
        <ChevronRightIcon
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s",
          }}
        />
      </ToggleSidebarButton>
      <Drawer
        variant="permanent"
        anchor={isRTL ? "right" : "left"}
        sx={{
          width: open ? drawerWidth : 70,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: open ? drawerWidth : 70,
            transition: "width 0.3s",
            // overflow: "hidden",
            boxSizing: "border-box",
            backgroundColor: "#fff",
            paddingTop: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: open ? "flex-start" : "center",
          },
        }}
      >
        <Box
          sx={{
            alignSelf: "center",
            marginBottom: open ? "15px" : "10px",
            transition: "all 0.3s",
          }}
        >
          {open ? (
            <>
              <Logo
                src={LogoNav}
                alt="Company Logo"
                style={{
                  width: "225px",
                  height: "40px",
                  marginBottom: "15px",
                }}
              />
              <ProfileContainer onClick={handleMenuClick}>
                <Avatar src={LogoNavCompany} alt="Profile" />
                <Box>
                  <Box sx={{ textAlign: isRTL ? "right" : "left" }}>
                    {ClientName}
                  </Box>
                  <ClientType>
                    {t("Navbar.prime_client")}
                    <IconButton>
                      <i
                        className="fas fa-chevron-down"
                        style={{ fontSize: "14px" }}
                      ></i>
                    </IconButton>
                  </ClientType>
                </Box>
              </ProfileContainer>
            </>
          ) : (
            <img
              src={MiniLogoIcon}
              alt="Mini Logo"
              style={{ width: 40, height: 40 }}
            />
          )}
        </Box>

        <DrawerContent>
          {[
            {
              label: t("Sidebar.Menu"),
              icon: <HomeIconSvg style={{ width: 24, height: 24 }} />,
              to: "/",
            },
            {
              label: t("Sidebar.Shipments"),
              icon: <ShipmentIconSvg style={{ width: 24, height: 24 }} />,
              to: "/reports/shipments",
            },
            {
              label: t("Sidebar.Pickups"),

              icon: <PickupIconSvg style={{ width: 24, height: 24 }} />,
              to: "/reports/pickups",
            },
            {
              label: t("Sidebar.Reports_ExportData"),

              icon: <ReportIconSvg style={{ width: 24, height: 24 }} />,
              to: "/reports/export-shipments",
            },
            {
              label: t("Sidebar.Analysis"),
              icon: <AnalysisIconSvg style={{ width: 24, height: 24 }} />,
              to: "/analysis",
            },

            {
              label: t("Sidebar.Support"),
              icon: <img src={TicketIcon} alt="" width={20} />,
              to: "/complaints",
            },
            {
              label: t("Sidebar.Transactions"),
              icon: <WalletSvgIcon style={{ width: 24, height: 24 }} />,
              to: "/transactions",
            },

            {
              label: t("Sidebar.Returns"),
              icon: <CardSvgIcon style={{ width: 24, height: 24 }} />,
              to: "/returns",
            },
          ].map((item, index) => (
            <Tooltip
              key={index}
              title={item.label}
              disableHoverListener={open}
              placement="right"
            >
              <DrawerItem component={NavLink} to={item.to} open={open}>
                {item.icon}
                {open && <span>{item.label}</span>}
              </DrawerItem>
            </Tooltip>
          ))}
          <Divider sx={{ my: 1, width: "100%" }} />
          {[
            {
              label: t("Sidebar.Settings"),

              icon: <SettingsIconSvg style={{ width: 20, height: 20 }} />,
              to: "/settings",
            },
            {
              label: t("Sidebar.Advanced_Search"),

              icon: <AdvancedSearchSvg style={{ width: 24, height: 24 }} />,
              to: "/multi-search",
            },
            {
              label: t("Sidebar.Messages"),
              icon: <MessageIconSvg style={{ width: 24, height: 24 }} />,
              to: "/messages",
            },
            {
              label: t("Sidebar.Quick_NewShipment"),
              icon: (
                <AddShipmentIconSvg
                  style={{ width: 24, height: 24 }}
                  stroke="#807e7eff"
                />
              ),
              to: "/quick-newshipment",
            },
            {
              label: t("Navbar.add_pickup"),

              icon: <AddPickupIconSvg style={{ width: 24, height: 24 }} />,
              to: "/new-pickup",
            },
            {
              label: t("Sidebar.Aliens_Assistant"),
              icon: <img src={AiIcon} alt="" width={20} />,
              to: "/ai-assistant",
            },
          ].map((item, index) => (
            <Tooltip
              key={`extra-${index}`}
              title={item.label}
              disableHoverListener={open}
              placement="right"
            >
              <DrawerItem component={NavLink} to={item.to} open={open}>
                {item.icon}
                {open && <span>{item.label}</span>}
              </DrawerItem>
            </Tooltip>
          ))}
        </DrawerContent>
      </Drawer>
    </SidebarWrapper>
  );
}
